<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title-2"><span>A NIGHT AT THE OPERA</span></p>
<p class="left-1">Rheingold! Rarest gold!</p>
<p class="left-1">O, might only thy purest magic waken again in the waves!</p>
<p class="left-1">What is of value can only dwell in the waters!</p>
<p class="left-1">Base and vile are those enthroned above!</p>
<p class="right1-1"><span>—<i>The Lament of the Rhein Maidens</i>,</span></p>
<p class="right1-1"><span><i>Richard Wagner</i>,</span></p>
<p class="right1-1"><span><i><span class="smallcaps">DAS RHEINGOLD</span>, Act I</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?0036752b